import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
interface OrderBumpsProps {
  bump1: boolean;
  bump2: boolean;
  setBump1: (val: boolean) => void;
  setBump2: (val: boolean) => void;
}
export function OrderBumps({
  bump1,
  bump2,
  setBump1,
  setBump2
}: OrderBumpsProps) {
  return <div className="flex flex-col gap-4 mt-8 mb-6 w-full relative z-[60]" data-id="element-284">
      {/* Order Bump 1 */}
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className={`relative rounded-xl border-2 border-dashed transition-all duration-200 cursor-pointer overflow-hidden ${bump1 ? 'bg-orange-50 border-terracotta shadow-lg' : 'bg-white border-terracotta hover:border-terracotta/90 animate-bump-glow'}`} onClick={() => setBump1(!bump1)} data-id="element-285">
        {/* Banner */}
        <div className="bg-terracotta flex items-center justify-center gap-2 py-1.5 px-3" data-id="element-286">
          <Star className="w-3.5 h-3.5 text-white fill-white" data-id="element-287" />
          <span className="text-[11px] font-bold uppercase tracking-wider text-white" data-id="element-288">
            Altamente Recomendado
          </span>
          <Star className="w-3.5 h-3.5 text-white fill-white" data-id="element-289" />
        </div>

        <div className="p-4" data-id="element-290">
          <div className="flex items-start gap-3" data-id="element-291">
            <div className={`shrink-0 w-6 h-6 mt-1 rounded border-2 flex items-center justify-center transition-colors ${bump1 ? 'bg-terracotta border-terracotta' : 'bg-white border-navy/30'}`} data-id="element-292">
              {bump1 && <Check className="w-4 h-4 text-white" data-id="element-293" />}
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/7wX1gWUf9Baa5o2RWKjpzF/Mockoup_Order_bump_1_-_Kit_de_Emergancia_en_el_Telefono.png" alt="Kit de Emergencia Móvil" className="w-14 h-14 object-contain rounded shrink-0" data-id="element-294" />
            <div className="flex-1 min-w-0" data-id="element-295">
              <h4 className="text-navy font-bold text-sm leading-snug" data-id="element-296">
                Kit de Emergencia en el Teléfono
              </h4>
              <p className="text-terracotta font-bold text-sm mt-0.5" data-id="element-297">
                + $6.00
              </p>
            </div>
          </div>
          <p className="text-xs text-navy/70 leading-relaxed mt-3" data-id="element-298">
            Transforma tu móvil en tu mejor aliado en urgencias. Ficha médica,
            log de crisis y acceso rápido desde tu pantalla de inicio. Todo lo
            que el médico necesita saber, a un solo clic.
          </p>
        </div>
      </motion.div>

      {/* Order Bump 2 */}
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.1
    }} className={`relative rounded-xl border-2 border-dashed transition-all duration-200 cursor-pointer overflow-hidden ${bump2 ? 'bg-orange-50 border-terracotta shadow-lg' : 'bg-white border-terracotta hover:border-terracotta/90 animate-bump-glow'}`} onClick={() => setBump2(!bump2)} data-id="element-299">
        {/* Banner */}
        <div className="bg-terracotta flex items-center justify-center gap-2 py-1.5 px-3" data-id="element-300">
          <Star className="w-3.5 h-3.5 text-white fill-white" data-id="element-301" />
          <span className="text-[11px] font-bold uppercase tracking-wider text-white" data-id="element-302">
            Altamente Recomendado
          </span>
          <Star className="w-3.5 h-3.5 text-white fill-white" data-id="element-303" />
        </div>

        <div className="p-4" data-id="element-304">
          <div className="flex items-start gap-3" data-id="element-305">
            <div className={`shrink-0 w-6 h-6 mt-1 rounded border-2 flex items-center justify-center transition-colors ${bump2 ? 'bg-terracotta border-terracotta' : 'bg-white border-navy/30'}`} data-id="element-306">
              {bump2 && <Check className="w-4 h-4 text-white" data-id="element-307" />}
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/c767RJfZcqcogXATGqXxm8/Mockoup_Order_bump_2_-_Manual_de_Conversaciones_Incomodas.png" alt="Manual de Conversaciones Incómodas" className="w-14 h-14 object-contain rounded shrink-0" data-id="element-308" />
            <div className="flex-1 min-w-0" data-id="element-309">
              <h4 className="text-navy font-bold text-sm leading-snug" data-id="element-310">
                Manual de Conversaciones Incómodas
              </h4>
              <p className="text-terracotta font-bold text-sm mt-0.5" data-id="element-311">
                + $6.00
              </p>
            </div>
          </div>
          <p className="text-xs text-navy/70 leading-relaxed mt-3" data-id="element-312">
            Guiones exactos para los temas más difíciles con tus padres. Cómo
            proponer cambios sin herir su orgullo. Qué responder cuando
            explotan. Sin gritos, sin culpa, con dignidad.
          </p>
        </div>
      </motion.div>
    </div>;
}